import { setSuccessAndStopLoading, setErrorAndStopLoading, startLoading, stopLoading } from '../../apps/components/Notifications'
import { ErrorLevel, AppError } from '../../classes/Errors'

export default {
  name: 'Test',
  template: `
  <div class="container section-margin">
    <div class="button-group">
      <button class="button button--primary" @click="testLoading">test loading</button>
      <button class="button button--green" @click="success">test success</button>
      <button class="button button--beige" @click="warning">test warning</button>
      <button class="button button--red" @click="error">test error</button>
      <button class="button button--red" @click="fatal">test fatal error</button>
    </div>
  </div>
  `,
  setup (props, { emit }) {
    function testLoading () {
      startLoading('test')
      setTimeout(() => { stopLoading('test') }, 2000)
    }

    function success () {
      setSuccessAndStopLoading({
        code: 'test',
        title: 'Registration successful',
        details: 'Your MaiStar Rewards Club is now activated. Your 500 Leaders Club points bonus will appear in your account within 48 hours.',
      })
    }

    function warning () {
      const err = new AppError('test warning notification', ErrorLevel.WARNING)
      setErrorAndStopLoading(err)
    }

    function error () {
      const err = new AppError('test error notification', ErrorLevel.ERROR)
      setErrorAndStopLoading(err)
    }

    function fatal () {
      const err = new AppError('test fatal error', ErrorLevel.FATAL)
      setErrorAndStopLoading(err)
    }

    return {
      testLoading,
      success,
      warning,
      error,
      fatal,
    }
  },
}
